module.exports = __webpack_public_path__ + "static/media/valora.d5baa0af.jpg";